export default {
    bindings: {
        'event': '<',
        'link': '<',
        'price': '<',
        'addClass': '@',
        'type': '@'
    },
    controller: 'eventTileController',
    template: require('../views/event.tile.html')
};



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/widget/components/event.tile.component.js